// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PinIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PinIcon" ref={forwardedRef} {...props}>
      <path d="M5.004 2.5h10v1.501H11.5V4h-3v.001H5.004z" />
      <path d="M8.5 4.001H7.004v4.5A5 5 0 0 0 5 12.5V13a1 1 0 0 0 1 1h3.25v3.5H9.8a5 5 0 0 0 .4 0h.55V14H14a1 1 0 0 0 1-1v-.5a5 5 0 0 0-1.997-3.995V4.002h-1.502v5.34A3.5 3.5 0 0 1 13.5 12.5h-2.75v-.004h-1.5V12.5H6.5a3.5 3.5 0 0 1 2-3.16z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PinIcon = /* @__PURE__ */ Object.assign(PinIconComponent, {
  displayName: 'PinIcon',
});
